import React from 'react';
import { Player } from 'video-react';
import './App.css';
// import "node_modules/video-react/dist/video-react.css"; // import css

class App extends React.Component {
  constructor(props) 
    { 
        super(props); 
        this.state = {
              poster : "",
              video : ""
           }; 
    } 
  componentWillMount(){
    var options = window.location.search.slice(1)
                  .split('&')
                  .reduce(function _reduce (/*Object*/ a, /*String*/ b) {
                    b = b.split('=');
                    a[b[0]] = decodeURIComponent(b[1]);
                    return a;
                  }, {});
    
    console.log(options,'ateeb');
    var url = "https://back.cricwick.net/api/v1/user_api/get_single_video?id="+options['v'];
    console.log(url);
    fetch(url)
      .then(res => res.json())
      .then(
        (result) => {
          console.log(result, "api response");
          document.title = result.video.title;
          this.setState({
            poster: result.video.med_image,
            video: result.video.qualities[1].video_file
          });
        },
        // Note: it's important to handle errors here
        // instead of a catch() block so that we don't swallow
        // exceptions from actual bugs in components.
        (error) => {
          this.setState({
            isLoaded: true,
            error
          });
        }
      )

  }
  render() {
    {console.log(this.state.poster)}
    return ( 
      <div className="App">
         <Player
            playsInline
            poster={this.state.poster}
            src={this.state.video}
          />
      </div>
    );
  }
}

export default App;
